module.exports = __webpack_public_path__ + "static/media/SerraLabs_Favicon_01.6c05ba66.ico";